import React from 'react';
import { node, oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  align: oneOf(['start', 'end']),
  children: node.isRequired,
};

const defaultProps = {
  align: 'start',
};

const CardAction = ({ align, children }) => {
  const classes = cx('c-card__action', {
    'c-card__action--end': align === 'end',
  });

  return <div className={classes}>{children}</div>;
};

CardAction.propTypes = propTypes;
CardAction.defaultProps = defaultProps;

export default CardAction;
